import { SimpleDashboard } from 'layouts/dash/types'

export default function CriticalAnalysisChart(props: SimpleDashboard) {
  return null
}
